export default {"src":"/_next/static/media/location.166a90fa.svg","height":13,"width":11,"blurWidth":0,"blurHeight":0};